var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaestro16 = function SvgMaestro16(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V13.5C24 14.8807 22.8807 16 21.5 16H2.5C1.11929 16 0 14.8807 0 13.5V2.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8537 7.945C13.8537 10.676 11.57 12.89 8.75295 12.89C5.93586 12.89 3.65216 10.676 3.65216 7.945C3.65216 5.21395 5.93586 3 8.75295 3C11.57 3 13.8537 5.21395 13.8537 7.945Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.471 7.945C20.471 10.676 18.1873 12.89 15.3702 12.89C12.5531 12.89 10.2694 10.676 10.2694 7.945C10.2694 5.21395 12.5531 3 15.3702 3C18.1873 3 20.471 5.21395 20.471 7.945Z",
    fill: "#0099DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0616 11.7087C13.1583 10.8017 13.8537 9.45206 13.8537 7.94499C13.8537 6.43792 13.1583 5.08831 12.0616 4.1813C10.9649 5.08831 10.2695 6.43792 10.2695 7.94499C10.2695 9.45206 10.9649 10.8017 12.0616 11.7087Z",
    fill: "#6C6BBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5H21.5V-0.5H2.5V0.5ZM23.5 2.5V13.5H24.5V2.5H23.5ZM21.5 15.5H2.5V16.5H21.5V15.5ZM0.5 13.5V2.5H-0.5V13.5H0.5ZM2.5 15.5C1.39543 15.5 0.5 14.6046 0.5 13.5H-0.5C-0.5 15.1569 0.843146 16.5 2.5 16.5V15.5ZM23.5 13.5C23.5 14.6046 22.6046 15.5 21.5 15.5V16.5C23.1569 16.5 24.5 15.1569 24.5 13.5H23.5ZM21.5 0.5C22.6046 0.5 23.5 1.39543 23.5 2.5H24.5C24.5 0.843146 23.1569 -0.5 21.5 -0.5V0.5ZM2.5 -0.5C0.843146 -0.5 -0.5 0.843146 -0.5 2.5H0.5C0.5 1.39543 1.39543 0.5 2.5 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaestro16);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "maestro-16.2f70b02746aac67d0b8f0bbdb3052bac.svg";